import { render, staticRenderFns } from "./MovieBg.vue?vue&type=template&id=3a454749&scoped=true&"
import script from "./MovieBg.vue?vue&type=script&lang=js&"
export * from "./MovieBg.vue?vue&type=script&lang=js&"
import style0 from "./MovieBg.vue?vue&type=style&index=0&id=3a454749&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a454749",
  null
  
)

export default component.exports